
import { Component, Vue, Prop } from "vue-property-decorator";
import { API_TDocumentCard } from "@/models/document_cards";
import { SMDocuments } from "@/store";

const ICONS = {
  documentTextOutline: "document-text-outline",
};

@Component({
  components: {
    ActionContainerCard: () => import("@/components/ActionContainer/ActionContainerCard.vue"),
  },
})
export default class DocumentCardDescription extends Vue {
  @Prop({ type: Object }) readonly documentCard?: API_TDocumentCard;

  icons = ICONS;

  get documentCardTitle() {
    return this.documentCard?.document_template.name || "";
  }

  get documentCardDescription() {
    return this.documentCard?.document_template.description || "";
  }

  get documentCardExamplePath() {
    return this.documentCard?.document_template.example_path || "";
  }

  get isError() {
    return this.documentCard?.status === "error";
  }

  async viewExample() {
    const data = await SMDocuments.getFileData();

    if (!data) return;

    const { link, name } = data;

    this.openPDFDialog(link, name);
  }

  openPDFDialog(link: string, name: string) {
    this.$emit("openPDFDialog", { link, name });
  }
}
